/**
 * MWS Portal Services
 * REST Services der Portal-Anwendung MWS
 *
 * The version of the OpenAPI document: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PriceVariant = 'FIX' | 'VARIABLE' | 'OPEN_PRICE';

export const PriceVariant = {
    Fix: 'FIX' as PriceVariant,
    Variable: 'VARIABLE' as PriceVariant,
    OpenPrice: 'OPEN_PRICE' as PriceVariant
};

